import { canEditSection } from '@/lib/access';
import React from 'react';
import { useManualForm, FormShell, NumberField, TextAreaField, RepeatTable } from './_shared';
import { Card } from '@/components/UI';

const DEFAULT = {
  summary: { energy_consumption_kwh: 0, energy_cost: 0, solar_generation_kwh: 0, water_consumption_kl: 0, hazardous_waste_kg: 0, non_hazardous_waste_kg: 0, scrap_sold_kg: 0, scrap_value: 0, enpi_kwh_per_lakh_revenue: 0, enpi_target: 20, carbon_footprint_tco2: 0, notes: '' },
  environmental_objectives: [],
  compliance_status: [],
};
const OBJ_COLS = [
  { key: 'objective', label: 'Objective', type: 'textarea' },
  { key: 'target', label: 'Target' },
  { key: 'actual', label: 'Actual' },
  { key: 'status', label: 'Status', type: 'select', options: ['on_track', 'at_risk', 'missed', 'achieved'] },
  { key: 'remarks', label: 'Remarks' },
];
const COMP_COLS = [
  { key: 'requirement', label: 'Requirement' },
  { key: 'authority', label: 'Authority' },
  { key: 'valid_until', label: 'Valid Until', type: 'date' },
  { key: 'status', label: 'Status', type: 'select', options: ['valid', 'expiring_soon', 'expired'] },
  { key: 'remarks', label: 'Remarks' },
];

export default function Environment() {
  const ctx = useManualForm('environment', DEFAULT);
  const canEdit = canEditSection(ctx.user, 'environment');
  const locked = ctx.currentCycle?.status === 'locked';
  const s = ctx.data.summary || DEFAULT.summary;
  const set = (k, v) => ctx.setData({ ...ctx.data, summary: { ...s, [k]: v } });
  const setKey = (k, rows) => ctx.setData({ ...ctx.data, [k]: rows });
  return (
    <FormShell title="Environment & Energy" subtitle="EMS / EnMS performance, objectives, compliance" status={ctx.status} save={ctx.save} submit={ctx.submit} saving={ctx.saving} submitting={ctx.submitting} canEdit={canEdit} locked={locked}>
      <Card title="Resource Use & Waste">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <NumberField label="Energy (kWh)" value={s.energy_consumption_kwh} onChange={(v) => set('energy_consumption_kwh', v)} disabled={!canEdit || locked} />
          <NumberField label="Energy Cost (₹)" value={s.energy_cost} onChange={(v) => set('energy_cost', v)} disabled={!canEdit || locked} />
          <NumberField label="Solar (kWh)" value={s.solar_generation_kwh} onChange={(v) => set('solar_generation_kwh', v)} disabled={!canEdit || locked} />
          <NumberField label="Water (KL)" value={s.water_consumption_kl} onChange={(v) => set('water_consumption_kl', v)} disabled={!canEdit || locked} />
          <NumberField label="Hazardous Waste (kg)" value={s.hazardous_waste_kg} onChange={(v) => set('hazardous_waste_kg', v)} disabled={!canEdit || locked} />
          <NumberField label="Non-Hazardous (kg)" value={s.non_hazardous_waste_kg} onChange={(v) => set('non_hazardous_waste_kg', v)} disabled={!canEdit || locked} />
          <NumberField label="Scrap Sold (kg)" value={s.scrap_sold_kg} onChange={(v) => set('scrap_sold_kg', v)} disabled={!canEdit || locked} />
          <NumberField label="Scrap Value (₹)" value={s.scrap_value} onChange={(v) => set('scrap_value', v)} disabled={!canEdit || locked} />
          <NumberField label="EnPI (kWh/Lakh ₹)" value={s.enpi_kwh_per_lakh_revenue} onChange={(v) => set('enpi_kwh_per_lakh_revenue', v)} disabled={!canEdit || locked} />
          <NumberField label="EnPI Target" value={s.enpi_target} onChange={(v) => set('enpi_target', v)} disabled={!canEdit || locked} />
          <NumberField label="Carbon Footprint (tCO₂)" value={s.carbon_footprint_tco2} onChange={(v) => set('carbon_footprint_tco2', v)} disabled={!canEdit || locked} />
        </div>
        <div className="mt-3"><TextAreaField label="Notes" value={s.notes} onChange={(v) => set('notes', v)} disabled={!canEdit || locked} /></div>
      </Card>
      <Card title="Environmental Objectives"><RepeatTable rows={ctx.data.environmental_objectives || []} columns={OBJ_COLS} onChange={(rows) => setKey('environmental_objectives', rows)} addLabel="Add Objective" defaultRow={{ status: 'on_track' }} /></Card>
      <Card title="Compliance Status"><RepeatTable rows={ctx.data.compliance_status || []} columns={COMP_COLS} onChange={(rows) => setKey('compliance_status', rows)} addLabel="Add Requirement" defaultRow={{ status: 'valid' }} /></Card>
    </FormShell>
  );
}
